import React from 'react'
import { Button, Card, Form, Input, Radio, Select, Space, Typography, message } from 'antd'
import { apiUrl } from '../../config/api'

function authHeaders() {
  const h = { 'Content-Type': 'application/json', Accept: 'application/json' }
  try {
    const s = localStorage.getItem('x-auth-secret')
    if (s) h['x-auth-secret'] = s
  } catch { /* ignore */ }
  return h
}

export default function AdminPushNotifications() {
  const [loading, setLoading] = React.useState(false)
  const [locations, setLocations] = React.useState([])
  const [locLoading, setLocLoading] = React.useState(false)
  const [form] = Form.useForm()
  const target = Form.useWatch('target', form)

  document.title = 'Admin — إشعارات'

  React.useEffect(() => {
    let cancelled = false
    async function loadLocs() {
      setLocLoading(true)
      try {
        const r = await fetch(apiUrl('/api/delivery-locations'), { headers: { Accept: 'application/json' } })
        if (!r.ok) throw new Error('failed')
        const json = await r.json()
        if (!cancelled) setLocations(Array.isArray(json) ? json : [])
      } catch (e) {
        console.error(e)
        message.error('فشل تحميل مناطق التوصيل')
      } finally {
        if (!cancelled) setLocLoading(false)
      }
    }
    loadLocs()
    return () => { cancelled = true }
  }, [])

  async function onFinish(values) {
    const secret = (() => {
      try { return localStorage.getItem('x-auth-secret') || '' } catch { return '' }
    })()
    if (!secret.trim()) {
      message.error('يرجى ضبط x-auth-secret من صفحة الإدارة الرئيسية أولاً')
      return
    }

    const payload = {
      target: values.target,
      title: (values.title || '').trim(),
      body: (values.body || '').trim(),
    }
    if (values.target === 'PHONE') {
      payload.phone = (values.phone || '').trim()
    }
    if (values.target === 'DELIVERY_LOCATION') {
      payload.deliveryLocationId = values.deliveryLocationId
    }

    setLoading(true)
    try {
      const r = await fetch(apiUrl('/api/admin/push/send'), {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify(payload),
      })
      const text = await r.text()
      if (!r.ok) {
        message.error(text || `خطأ ${r.status}`)
        return
      }
      let json
      try {
        json = JSON.parse(text)
      } catch {
        message.success('تم الإرسال')
        return
      }
      message.success(
        `تم: نجح ${json.successCount ?? '—'} / استهدف ${json.tokensTargeted ?? '—'} جهاز`
      )
      form.resetFields(['title', 'body', 'phone'])
    } catch (e) {
      console.error(e)
      message.error('فشل الإرسال')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{ maxWidth: 640, margin: '40px auto', padding: '0 16px' }}>
      <Typography.Title level={4} style={{ marginTop: 0 }}>إرسال إشعار للتطبيق</Typography.Title>
      <Typography.Paragraph type="secondary">
        العنوان يظهر كسطر رئيسي، والنص الفرعي كسطر ثانٍ في إشعار النظام (مثل باقي التطبيقات).
        {' '}
        «الجميع» و«منطقة توصيل» تشمل أيضاً أجهزة الزوار الذين لم يسجّلوا دخولاً (بعد اختيارهم للمنطقة في التطبيق).
        «رقم هاتف» يستهدف المستخدمين المسجّلين فقط الذين يملكون هذا الرقم.
      </Typography.Paragraph>

      <Card>
        <Form
          form={form}
          layout="vertical"
          initialValues={{ target: 'ALL' }}
          onFinish={onFinish}
        >
          <Form.Item name="target" label="الجمهور" rules={[{ required: true }]}>
            <Radio.Group>
              <Radio.Button value="ALL">جميع المستخدمين</Radio.Button>
              <Radio.Button value="PHONE">رقم هاتف محدد</Radio.Button>
              <Radio.Button value="DELIVERY_LOCATION">منطقة توصيل</Radio.Button>
            </Radio.Group>
          </Form.Item>

          {target === 'PHONE' && (
            <Form.Item
              name="phone"
              label="رقم الهاتف"
              rules={[{ required: true, message: 'أدخل الرقم' }]}
            >
              <Input placeholder="0595066042" dir="ltr" style={{ direction: 'ltr' }} />
            </Form.Item>
          )}

          {target === 'DELIVERY_LOCATION' && (
            <Form.Item
              name="deliveryLocationId"
              label="منطقة التوصيل"
              rules={[{ required: true, message: 'اختر المنطقة' }]}
            >
              <Select
                loading={locLoading}
                placeholder="اختر المنطقة"
                options={locations.map((l) => ({ value: l.id, label: l.nameAr || l.name || `#${l.id}` }))}
                showSearch
                optionFilterProp="label"
              />
            </Form.Item>
          )}

          <Form.Item name="title" label="عنوان الإشعار (السطر الرئيسي)" rules={[{ required: true, message: 'مطلوب' }]}>
            <Input maxLength={120} showCount />
          </Form.Item>

          <Form.Item name="body" label="النص الفرعي" rules={[{ required: true, message: 'مطلوب' }]}>
            <Input.TextArea rows={3} maxLength={500} showCount />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" loading={loading}>
                إرسال
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}
